"use client";

import { useState, useRef, useEffect } from "react";
import type { OrdenacaoVagas } from "../../types/vaga";

interface OrderSelectProps {
  value: OrdenacaoVagas;
  onChange: (value: OrdenacaoVagas) => void;
}

const orderOptions: { value: OrdenacaoVagas; label: string }[] = [
  { value: "recente", label: "Mais recente" },
  { value: "az", label: "Alfabético A-Z" },
  { value: "za", label: "Alfabético Z-A" },
];

export default function OrderSelect({ value, onChange }: OrderSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLabel =
    orderOptions.find((opt) => opt.value === value)?.label || "Mais recente";

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 text-base text-text-secondary hover:text-text-primary transition-colors cursor-pointer self-start"
      >
        <span>Ordenar por: {currentLabel}</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        >
          <path d="M7 10L12 15L17 10H7Z" fill="currentColor" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-50 top-full right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 min-w-[180px] overflow-hidden">
          {orderOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 cursor-pointer ${
                value === option.value
                  ? "bg-blue-50 text-blue-main font-medium"
                  : "text-text-primary"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
